// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import { FileKind } from "../../../../define/FileKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import OrchardGoods from "./OrchardGoods";


const {ccclass, property} = cc._decorator;

@ccclass
export default class OrchardGoodsGetProp extends OrchardGoods {

    @property({tooltip: '道具id'})
    propId: number = 0;
   
    collideEffect() {
        this.bGoodsValid = false;
        
        let goodsConfig = backPackEventMap()[this.propId];
        if (!goodsConfig) {
            this.destroyNode();
            return;
        }

        let parent = this._carryData.parent;
        parent.setStop(true);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.BravoGetGoodsLayer
            , null
            , {
                id: this.propId
                , pushBackpackCab: ()=> {
                    O1HD.emit(MessageEventKind.EventName.REFRESH_ORCHARD_COLLECT_STATE);
                }
                , exit: ()=> {
                    parent.setStop(false);
                    this.destroyNode();
                }
            }
        );
    }

    // update (dt) {}
}
